<div class="modal-header" medptevlog>
  <h2 class="modal-title" id="modal-title">Question</h2>
  <span type="button" class="btn-close" (click)="modal.dismiss('')" medpt-log-action="CloseModel" medpt-log-message="CloseModel submit a question"></span>
</div>
<div class="modal-body" medptevlog>
  <style>
  </style>
  <form class="form-horizontal" [formGroup]="questionform" (ngSubmit)="onSubmitQuestion()" id="questionform">
    <div class="row">
      <div class="col col-md-12">

      </div>
    </div>
    <div class="row">
      <label class="col-sm-1 col-form-label">From: </label>
      <div class="col-sm-10">
        <label class="col-form-label"><span [innerHTML]="currentUser.FullName"></span></label>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-1 col-form-label">Date: </label>
      <div class="col-sm-10">
        <label class="col-form-label">{{date}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 mb-2">
        <label class="col-form-label">Category <span class="text-danger"> *</span></label>

        <kendo-dropdownlist formControlName="category"
                            [ngClass]="{'is-invalid': questionform.controls['category'].invalid && (questionform.controls['category'].touched || submitted),'disabled':isSuccess}"
                            [data]="filteredData"
                            [defaultItem]="categoryDefaultItem"
                            [valuePrimitive]="true"
                            textField="CategoryName"
                            valueField="_MessageCategoryID"
                            [filterable]="true"
                            (filterChange)="filterData($event)">
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <span [innerHTML]="dataItem.CategoryName"></span>
          </ng-template>
        </kendo-dropdownlist>
        <span class="text-danger small" *ngIf="(questionform.controls['category'].touched || submitted) && questionform.controls['category'].errors?.['required']">Category is required</span>
      </div>
      <div class="col-sm-12 mb-2">
        <label class="col-form-label">Title <span class="text-danger"> *</span></label>
        <input type="text" class="mb-0" formControlName="title" [ngClass]="{'is-invalid': questionform.controls['title'].invalid && (questionform.controls['title'].touched || submitted),'disabled':isSuccess}" placeholder="Enter title"/>
        <span class="text-danger small" *ngIf="(questionform.controls['title'].touched || submitted) && questionform.controls['title'].errors?.['required']">Title is required</span>
      </div>
      <div class="col-sm-12 mb-2">
        <label class="col-form-label">Question <span class="text-danger"> *</span></label>
        <textarea class="mb-0" style="height: 93px;" formControlName="question" [ngClass]="{'is-invalid': questionform.controls['question'].invalid && (questionform.controls['question'].touched || submitted),'disabled':isSuccess}" placeholder="Enter your question" maxlength="1000"></textarea>
        <span id="lbltxtQuestionCount" class="d-block remaning small" style="font-weight:lighter">Remaining characters : {{1000 - questionform.controls['question'].value?.length}}</span>
        <span class="d-block is-invalid-message small" *ngIf="(questionform.controls['question'].touched || submitted) && questionform.controls['question'].errors?.['required']">Question is required</span>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer" medptevlog>
  <ng-container *ngIf="isSuccess; then success; else default">
  </ng-container>
  <ng-template #success>
    <ng-container *ngIf="currentUrl.includes('AskAQuestionInbox') else gotoinbox">
      <button type="button" class="primaryBtn" form="questionform" (click)="reload()" ngbAutofocus>My Questions</button>
    </ng-container>
  </ng-template>
  <ng-template #gotoinbox>
    <button type="button" class="primaryBtn" form="questionform" (click)="goToInbox()" ngbAutofocus medpt-log-action="Click" medpt-log-message="Navigate to QuestionsInbox page">My Questions</button>
  </ng-template>  
  <ng-template #default>
    <button type="button" class="secondaryBtn" (click)="resetForm()">Clear</button>
    <button type="submit" class="primaryBtn" form="questionform" ngbAutofocus medpt-log-action="Submit" medpt-log-message="Save submit a question">Submit</button>
  </ng-template>
</div>

